// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 400px) {
  #features {
    padding: 20px;
  }
  #about,
  #services,
  #products,
  #testimonials,
  #team,
  #contact,
  #footer {
    padding-left: 15px;
    padding-right: 15px;
  }

  #portfolio {
    padding-left: 15px;
    padding-right: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;EACA;;;;;;;IAOE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["@media screen and (max-width: 400px) {\n  #features {\n    padding: 20px;\n  }\n  #about,\n  #services,\n  #products,\n  #testimonials,\n  #team,\n  #contact,\n  #footer {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  #portfolio {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
